import { Component } from '@angular/core';
import { SidebarContentComponent } from '../sidebar/sidebar-content-component';
import { HomeworkService } from '../../../services/homework.service';
import { HomeworkTipComponent } from './homework/homework-tip/homework-tip.component';
import { TestGeneratorComponent } from './test-generator/test-generator.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { HomeworkComponent } from './homework/homework.component';
import { ApplicationStateService } from '../../../services/application-state.service';

@Component({
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    standalone: true,
    imports: [
        HomeworkTipComponent,
        TestGeneratorComponent,
        PortfolioComponent,
        HomeworkComponent
    ]
})
export class TasksComponent implements SidebarContentComponent {
    constructor(public homeworkService: HomeworkService,
                public applicationStateService: ApplicationStateService) {
    }
}
